import { Add, GridView } from '@mui/icons-material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import HeaderTable from '../../Components/HeaderTable/HeaderTable';
import { ButtonTable } from '../../Layouts/ButtonsControlled';
import { getAllPanels, reset } from '../../Redux/PanlesSlice/PanelsSlice';
import PanelsTable from './PanelTable';
import { useLocation, useParams } from 'react-router-dom';
import { openModal } from '../../Redux/modalSlice';
import ModalContainer from '../../Components/Modal/ModalContainer';
import CreatePanels from './CreatePanels';
import { Outlet } from 'react-router-dom';
const Panels = () => {
	const location = useLocation();
	const path = location.pathname.split('/')[2];

	const parms = useParams();

	const dispatch = useDispatch();
	const { panels, isSuccess, isLodaing, isError } = useSelector(
		(state) => state.panels,
	);

	useEffect(() => {
		const fn = async () => {
			await dispatch(getAllPanels());
			await dispatch(reset());
		};
		fn();
	}, [parms.type]);

	return (
		<>
			<ModalContainer>
				<CreatePanels />
			</ModalContainer>
			<HeaderTable>
				<div className="title">
					<GridView />
					<span>{path}</span>
				</div>
				<ButtonTable startIcon={<Add />} onClick={() => dispatch(openModal())}>
					New
				</ButtonTable>
			</HeaderTable>
			<Outlet />
		</>
	);
};

export default Panels;
